<script>

export default {
  page: {
    title: '數據分析',
    meta: [{ name: 'description', content: 'Customer Analytics' }],
  },
  components: {},
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      activeTab: '1',
      // ifShow:false,
      tabList: Object.freeze([
        {
          title: '依店家類型',
          component: () => import('./TabIncomeProduct'),
        },
      ]),
    }
  },
  computed: {},
  mounted() {
    this.activeTab = '1'
  },
  created() {
  },
  methods: {
    toClick() {
    }
  },
}
</script>

<template>
  <div>
    <el-tabs ref="tab" v-model="activeTab" stretch class="is-no-border is-no-bg isStyleBaseLine isSecond"
      :class="$style.innerTabStyle" @tab-click="toClick">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index + 1}`">
      </el-tab-pane>
    </el-tabs>
    <div v-for="(tab, index) in tabList" :key="index">
      <component :is="tab.component" v-if="Number(activeTab) === index + 1" :merchant-products="merchantProducts">
      </component>
    </div>
  </div>
</template>
<style lang="scss" module >
.innerTabStyle {
  background-color: $color-body-bg;
  :global {
    .el-tabs__header {
      margin-top: -15px;
      margin-bottom: 5px;
      padding-bottom: 1px;
      box-shadow: 0 2px 5px #EFF0F1;
      margin-left: -15px;
      margin-right: -15px;

      .el-tabs__item {
        padding-left: 0;
        padding-right: 0;
        background-color: $color-body-bg !important;
        &:last-child {
          border-right:1px solid #E5E7EB;
        }
        &.is-active {
          background-color: $color-body-bg !important;
        }
      }
    }
  }
}

:global {
  .is-second {
    .el-tabs__active-bar {
      // width: 100% !important;
      // transform: translateX(105.828px)!important;
      // margin-left:7%;
      // font-size: 16px;
    }


    .el-tabs__nav.is-stretch {
      // padding-left: 8%;
      // padding-right: 8%;
    }

    .el-tabs__item {
      font-size: 14px !important;

      // padding-left: 9% !important;
      // padding-right: 9% !important;
      &.is-active {
        font-weight: normal;
        color: $color-primary !important;
      }
    }
  }

  // .el-tabs--border-card .el-tabs__item:not([id=tab-byOrder]):not([id=tab-bySize]):after {
  //   background: none;
  // }
}
</style>
